import { useEffect, useState, useContext } from "react"
import { MulticallContractWeb3 } from "../hooks/useContracts";
import { toast } from "react-toastify";
import { getDaoContract, getNFTContract } from "./contractHelper";
import { IPFS_URL } from "./constant";
import axios from "axios";
import { Context } from "../context/context";
import { useAccount } from "wagmi";

export const useProposalStats = (updater) => {
    let { setProgress } = useContext(Context);
    let { page, pageSize, oldData } = updater;
    const [stats, setStats] = useState({
        proposals: [],
        lastId: 0,
        loading: true
    });

    const daoContract = getDaoContract();

    useEffect(() => {
        const fetch = async () => {
            setProgress(40)
            try {

                const data = await MulticallContractWeb3([
                    daoContract.methods.proposalId(), //0
                ])
                let proposals = [];
                if (data[0] > 0) {
                    let totalPages = Math.ceil(data[0] / pageSize);
                    let start = totalPages - page > 0 ? (totalPages - page) * pageSize : 1;
                    let end = start + pageSize <= data[0] ? start + pageSize - 1 : data[0];
                    if (end <= 0) {
                        end = 1;
                    }

                    let callArray = [];
                    let z = 0;
                    for (let i = end; i >= start; i--) {
                        callArray[z] = daoContract.methods.proposals(i);
                        z++;
                    }
                    proposals = await MulticallContractWeb3(callArray);

                }

                setProgress(60)

                Promise.all(proposals.map(async (rowdata) => {
                    let ipfsText = await axios.get(`${IPFS_URL}${rowdata[2]}`);

                    let title = '';
                    let description = '';
                    let images = '';
                    let thumb = '';
                    if (ipfsText.status === 200 && ipfsText.data && ipfsText.data !== '') {
                        title = ipfsText.data.title;
                        description = ipfsText.data.description;
                        images = ipfsText.data.images;
                        thumb = ipfsText.data.thumb;
                    }


                    return { ...rowdata, title, description, images , thumb };
                })).then((response) => {
                    setProgress(100);
                    setStats({
                        proposals: oldData.concat(response),
                        lastId: data[0],
                        loading: false,

                    })
                })





            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason);
                setStats({
                    proposals: [],
                    lastId: 0,
                    loading: false
                })
                setProgress(100);


            }

        }

        if (daoContract) {
            fetch();
        }
        // eslint-disable-next-line
    }, [updater]);

    return stats;
}

export const useProposalIdStats = (id, updater) => {
    let { setProgress } = useContext(Context);
    const { address: account } = useAccount();
    const [stats, setStats] = useState({
        id: id,
        author: '',
        title: '',
        description: '',
        images: '',
        createAt: 0,
        totalOption: 0,
        status: '',
        loading: true,
        getProposalUserVote: false,
        getProposalVotes: 0,
        totalPower: 0,
    
    });

    const daoContract = getDaoContract();
    const nftContract = getNFTContract();

    useEffect(() => {
        const fetch = async () => {
            setProgress(40);
            if (id) {
                try {

                    const data = await MulticallContractWeb3(
                        account ? [
                            daoContract.methods.proposals(id), //0
                            daoContract.methods.getProposalOptions(id), //1
                            daoContract.methods.getProposalVotes(id), //2
                            daoContract.methods.getVotingWeightLength(),  //3
                            daoContract.methods.getPower(),  //4
                            daoContract.methods.getProposalUserVote(id, account) //5
                        ] :
                            [
                                daoContract.methods.proposals(id), //0
                                daoContract.methods.getProposalOptions(id), //1
                                daoContract.methods.getProposalVotes(id), //2
                                daoContract.methods.getVotingWeightLength(),  //3
                                daoContract.methods.getPower()  //4
                            ]
                    )
                    setProgress(50);

                    let title = '';
                    let description = '';
                    let images = '';
                    let thumb = ''

                    if (data[0][2]) {
                        let ipfsText = await axios.get(`${IPFS_URL}${data[0][2]}`);
                        if (ipfsText.status === 200 && ipfsText.data && ipfsText.data !== '') {
                            title = ipfsText.data.title;
                            description = ipfsText.data.description;
                            images = ipfsText.data.images;
                            thumb = ipfsText.data.thumb;
                        }
                    }

          

                    setStats({
                        id: id,
                        author: data[0][1],
                        title,
                        description,
                        images,
                        thumb,
                        createAt: data[0][3],
                        totalOption: data[1],
                        status: data[0][4],
                        loading: false,
                        getProposalUserVote: data[5] ? data[5] : false,
                        getProposalVotes: data[2],
                        totalPower: data[0][7]
                    })

                    setProgress(100);



                }
                catch (err) {
                    console.log(err.message);
                    toast.error(err.reason);
                    setProgress(100);

                }
            }

        }

        fetch();

        // eslint-disable-next-line
    }, [updater, id, account]);

    return stats;
}





